export default "__VITE_ASSET__CZiEP2Rj__"